module.exports = __webpack_public_path__ + "static/media/search-sort-descending.8dd7c081.svg";